<template>
  <div
    class="event-card"
    :id="iFollowed.details.id"
    :style="{
      width: iFollowed.duration * columnWidth + unityColumnWidth,
      backgroundColor: iFollowed.color,
    }"
    @mouseup="showEvent(iFollowed)"
  >
    <div class="iconsOptions">
      <div class="options">
        <v-icon
          :title="$t('enumIntStatus.interventionSuivie')"
          class="v-icon iconCell"
          :style="iFollowed.details.advInterventionDto.validated
          ? iFollowed.details.advInterventionDto.type === 'INTRA'
            ? {
                color: iFollowed.color,
              }
            : {
                color: '#ffffff',
              }
          : {
              color: iFollowed.color,
            }"
          :draggable="false"
        >
          mdi-school
        </v-icon>
      </div>
      <div
        class="redDot"
        v-if="iFollowed.details.advInterventionDto.comment"
        :title="iFollowed.details.advInterventionDto.comment"
      ></div>
    </div>

    <p
      :title="iFollowed.course"
      v-bind:style="
        iFollowed.details.advInterventionDto.validated
          ? iFollowed.details.advInterventionDto.type === 'INTRA'
            ? {
                backgroundColor: '#ffd320',
                color: iFollowed.color,
                fontWeight: 'bold',
              }
            : {
                background: iFollowed.color,
                color: '#ffffff',
                fontWeight: 'bold',
              }
          : {
              background: '#FFFFCC',
              color: iFollowed.color,
              fontWeight: 'bold',
            }
      "
    >
      {{ iFollowed.course }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["iFollowed", "columnWidth", "unityColumnWidth"],
  data() {
    return {
      stripeBg: {
        background: `repeating-linear-gradient(45deg, #ecd54f , #ecd54f 20px, ${this.iFollowed.color} 20px, ${this.iFollowed.color} 40px)`,
      },
      normalBg: { background: this.iFollowed.color },
    };
  },
  methods: {
    showEvent(iFollowed) {
      this.$emit("show-event", iFollowed);
    },
  },
};
</script>

<style lang="scss">
.event-card {
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  height: var(--row-height);
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

.event-card p {
  width: 100%;
  height: 100%;
  padding: 1.5rem 0 0 5px;
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
  color: rgb(36, 36, 36);
}

.event-card .v-btn {
  position: absolute;
  right: 20px;
  top: 5px;
}

.event-card .iconsOptions {
  position: absolute;
  display: grid;
  grid-template-columns: repeat(3, 3, 1fr);
  grid-column-gap: 0.1rem;
  justify-content: center;
  align-items: center;
  padding-left: 0.2rem;

  .iconCell {
    font-size: 1.1rem;
    color: rgb(36, 36, 36);
  }

  .optionIconCell {
    font-size: 1.1rem;
    color: #ffffcc;
  }

  .redDot {
    background: rgb(255, 69, 69);
    height: 8px;
    width: 8px;
    border-radius: 5px;
    cursor: help;
  }

  .options {
    cursor: help;
  }
}

.drop-preview {
  height: var(--row-height);
  background-color: rgba(180, 180, 180, 0.658);
}
</style>
